
/**
 * BLOCK: COntact Details Block Deprecated.
 */
import { range, createButtonAttributes } from '~cartzillagb/util'
import { applyFilters } from '@wordpress/hooks'
import {
	RichText 
} from '@wordpress/block-editor'
import { name } from './index'
import { pluginAssetsURL } from 'cartzillagb'
import {
	ButtonEditHelper
} from '~cartzillagb/components'
import classnames from 'classnames'
import {
	Fragment
} from '@wordpress/element'


const schema_1 = {
    blockId: {
        type: 'string',
        default: '',
    },
    limit: {
        type: 'number',
        default: 1,
    },
    bannerlimit: {
        type: 'number',
        default: 3,
    },
    bgcolor: {
        type: 'string',
    },
    custombgcolor: {
        type: 'string',
    },
    enableButton: {
        type: 'boolean',
        default: true
    },

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit_1 = applyFilters( 'cartzillagb.hero-carousel-2.icon.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit_1 + 1 ).map( i => {
    schema_1[ `pretitle${ i }` ] = {
        type: 'string',
    }
    schema_1[ `title${ i }` ] = {
        type: 'string',
    }
    schema_1[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema_1[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema_1[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema_1[ `mediaURL1${ i }` ] = {
        type: 'string',
    }
    schema_1[ `enablepreTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_1[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_1[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    return ""
} ) }

const BannerMaxlimit_1 = applyFilters( 'cartzillagb.hero-carousel-2.icon.edit.inspector.max.bannerlimit', 3 ) 

{ range( 1, BannerMaxlimit_1 + 1 ).map( j => {
    schema_1[ `bannertitle${ j }` ] = {
        type: 'string',
    }
    schema_1[ `shoplink${ j }` ] = {
        type: 'string',
    }
    schema_1[ `link${ j }` ] = {
        type: 'string',
    }
    schema_1[ `mediaURL2${ j }` ] = {
        type: 'string',
    }
    schema_1[ `bannerbgcolor${ j }` ] = {
        type: 'string',
    }
    schema_1[ `bannercustombgcolor${ j }` ] = {
        type: 'string',
    }
    schema_1[ `bannertextcolor${ j }` ] = {
        type: 'string',
    }
    schema_1[ `custombannertextcolor${ j }` ] = {
        type: 'string',
    }
        return ""
} ) }


const schema_2 = {
    blockId: {
        type: 'string',
        default: '',
    },
    limit: {
        type: 'number',
        default: 1,
    },
    bannerlimit: {
        type: 'number',
        default: 3,
    },
    bgcolor: {
        type: 'string',
    },
    custombgcolor: {
        type: 'string',
    },
    enableButton: {
        type: 'boolean',
        default: true
    },

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        isShadow: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit_2 = applyFilters( 'cartzillagb.hero-carousel-2.icon.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit_2 + 1 ).map( i => {
    schema_2[ `pretitle${ i }` ] = {
        type: 'string',
    }
    schema_2[ `title${ i }` ] = {
        type: 'string',
    }
    schema_2[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema_2[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema_2[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema_2[ `mediaURL1${ i }` ] = {
        type: 'string',
    }
    schema_2[ `enablepreTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_2[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_2[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    return ""
} ) }

const BannerMaxlimit_2 = applyFilters( 'cartzillagb.hero-carousel-2.icon.edit.inspector.max.bannerlimit', 3 ) 

{ range( 1, BannerMaxlimit_2 + 1 ).map( j => {
    schema_2[ `bannertitle${ j }` ] = {
        type: 'string',
    }
    schema_2[ `shoplink${ j }` ] = {
        type: 'string',
    }
    schema_2[ `link${ j }` ] = {
        type: 'string',
    }
    schema_2[ `mediaURL2${ j }` ] = {
        type: 'string',
    }
    schema_2[ `bannerbgcolor${ j }` ] = {
        type: 'string',
    }
    schema_2[ `bannercustombgcolor${ j }` ] = {
        type: 'string',
    }
    schema_2[ `bannertextcolor${ j }` ] = {
        type: 'string',
    }
    schema_2[ `custombannertextcolor${ j }` ] = {
        type: 'string',
    }
        return ""
} ) }


const save_1 = props => {
	const { 
		attributes,
		className
	} = props 

	const {
		blockId,
		limit,
		bannerlimit,
		custombgcolor,
		bgcolor,
		enableButton
	} = attributes

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const bgstyle = { backgroundColor: custombgcolor && custombgcolor }

	const content = range( 1, limit + 1 ).map( i => {

		const Pretitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const MediaURL1 = attributes[ `mediaURL1${ i }` ]
		const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
		const enableTitle = attributes[ `enableTitle${ i }` ]
		const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

		let defaultPretitle = ''
		let defaultTitle = ''
		let defaultSubtitle = ''
		let defaultImg = ''

		if ( i % 5 === 1 ) {
			defaultPretitle = 'World of music with'
			defaultTitle = 'Headphones'
			defaultSubtitle = 'Choose between top brands'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img4.jpg`
		}
		if ( i % 5 === 2 ) {
			defaultPretitle = 'Explore the best'
			defaultTitle = 'VR Collection'
			defaultSubtitle = 'on the market'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img5.jpg`
		}
		if ( i % 5 === 3 ) {
			defaultPretitle = 'Check our huge'
			defaultTitle = 'Smartphones'
			defaultSubtitle = '& Accessories collection'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img6.jpg`
		}
		if ( i % 5 === 4 ) {
			defaultPretitle = 'World of music with'
			defaultTitle = 'Headphones'
			defaultSubtitle = 'Choose between top brands'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img4-1.jpg`
		}
		if ( i % 5 === 0 ) {
			defaultPretitle = 'Explore the best'
			defaultTitle = 'VR Collection'
			defaultSubtitle = 'on the market'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img5-1.jpg`
		}

		const pretitleComp = enablepreTitle && (
			<RichText.Content
				tagName="h2"
				value={ Pretitle || defaultPretitle }
				className={ `font-weight-light pb-1 from-bottom text-dark` }
			/>
		)

		const titleComp = enableTitle && (
			<RichText.Content
				tagName="h1"
				className={ `display-4 from-bottom delay-1 text-dark` } 
				value={ Title || defaultTitle }
			/>
		)

		const subtitleComp = enablesubTitle &&  (
			<RichText.Content
				tagName="h5"
				value={ subTitle || defaultSubtitle }
				className={ `font-weight-light pb-3 from-bottom delay-2 text-dark` }
			/>
		)

		const buttonComp = enableButton && (
			<ButtonEditHelper.Content
				attrNameTemplate={ `button${ i }%s"` }
				blockAttributes={ props.attributes }
			/>
		)

		const output = (
			<div className="slide-wrapper" key={ i }>
				<div className="row align-items-center" key={ i }>
					<div className="col-md-6 order-md-2">
						<img className="d-block mx-auto" src={ MediaURL1 !== undefined ? MediaURL1 : defaultImg } alt="Vr Collection" />
					</div>
					<div className="col-lg-5 col-md-6 offset-lg-1 order-md-1 pt-4 pb-md-4 text-center text-md-left">
						{ pretitleComp }
						{ titleComp }
						{ subtitleComp }
						{ buttonComp }
					</div>
				</div>
			</div>
		)
			
		return output
	} )

	const sidecontent = range( 1, bannerlimit + 1 ).map( j => {

		const bannerTitle = attributes[ `bannertitle${ j }` ]
		const link = attributes[ `link${ j }` ] !== undefined ? attributes[ `link${ j }` ]  : '#'
		const MediaURL2 = attributes[ `mediaURL2${ j }` ]
		const shopLink = attributes[ `shoplink${ j }` ]
		const bannerbgcolor = attributes[ `bannerbgcolor${ j }` ]
		const bannercustombgcolor = attributes[ `bannercustombgcolor${ j }` ]
		const bannertextcolor = attributes[ `bannertextcolor${ j }` ]
		const custombannertextcolor = attributes[ `custombannertextcolor${ j }` ]

		const bannerbgstyle = { backgroundColor: bannercustombgcolor && bannercustombgcolor }


		let defaultbannerTitle = ''
		let defaultShopLink = ''
		let defaultImg = ''

		if ( j % 3 === 1 ) {
			defaultbannerTitle = '<span class="font-weight-light">Next Gen</span><br>Video <span class="font-weight-light">with</span><br>360 Cam'
			defaultImg = `${ pluginAssetsURL }img/banner/img1.png`
			defaultShopLink = 'Shop Now <i class="czi-arrow-right font-size-xs ml-1"></i>' 
		}
		if ( j % 3 === 2 ) {
			defaultbannerTitle = '<span class="font-weight-light">Top Rated</span><br>Gadgets<br><span class="font-weight-light">are on </span>Sale'
			defaultImg = `${ pluginAssetsURL }img/banner/img2.png`
			defaultShopLink = 'Shop Now <i class="czi-arrow-right font-size-xs ml-1"></i>' 
		}
		if ( j % 3 === 0 ) {
			defaultbannerTitle = '<span class="font-weight-light">Catch Big</span><br>Deals <span class="font-weight-light">on</span><br>Earbuds'
			defaultImg = `${ pluginAssetsURL }img/banner/img3.png`
			defaultShopLink = 'Shop Now <i class="czi-arrow-right font-size-xs ml-1"></i>' 
		}

		const BannerTitle =(
			<RichText.Content
				tagName="h5"
				value={ bannerTitle || defaultbannerTitle }
				className={ `mb-2` }
			/>
		)
		const ShopLink =(
			<RichText.Content
				tagName="div"
				value={ shopLink || defaultShopLink }
				className={ `${ bannertextcolor ? bannertextcolor : custombannertextcolor ? '' : j === 1 ? 'text-info' : j === 2 ? 'text-warning' : j === 3 ? 'text-success' : ''  } font-size-sm` }
				style={ { color: custombannertextcolor } }
			/>
		)
		const output = (
			<a className={ `media w-100 align-items-center ${ bannerbgcolor ? bannerbgcolor : bannercustombgcolor ? '' : j === 1 ? 'bg-faded-info' : j === 2 ? 'bg-faded-warning' : j === 3 ? 'bg-faded-success' : '' } rounded-lg pt-2 pl-2 mb-4 mr-4 mr-xl-0 ` } href={ link } style={ bannerbgstyle }  key={ j }>
				<img src={ MediaURL2 !== undefined ? MediaURL2 : defaultImg } width="125" alt="Banner" />
				<div className="media-body py-4 px-2">
					{ BannerTitle }
					{ ShopLink }
				</div>
			</a>
		)

		return output
	} )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-2.main-block.classes', {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots : true,
		arrows : false,
		adaptiveHeight : true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		speed: 500,
		pauseOnHover: true,
	}, props )

	let carouselOptions = {
		slidesToShow: 1,
		dots: true,
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
	] )

	return (
		<div id={ blockId } className={ mainClasses }>
			<section className={ `${ bgcolor ? bgcolor : custombgcolor ? '' : 'bg-secondary' } py-4 pt-md-5` } style={ bgstyle } >
				<div className="container py-xl-2">
					<div className="row align-items-center">
						<div className="col-xl-9 pt-xl-4 order-xl-2">
							<div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</div>
						<div className="col-xl-3 order-xl-1 pt-4 mt-3 mt-xl-0 pt-xl-0">
							<div className="d-flex d-xl-block sidebanner">
								{ sidecontent }
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

const save_2 = props => {
	const { 
		attributes,
		className
	} = props 

	const {
		blockId,
		limit,
		bannerlimit,
		custombgcolor,
		bgcolor,
		enableButton
	} = attributes

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const bgstyle = { backgroundColor: custombgcolor && custombgcolor }

	const content = range( 1, limit + 1 ).map( i => {

		const Pretitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const MediaURL1 = attributes[ `mediaURL1${ i }` ]
		const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
		const enableTitle = attributes[ `enableTitle${ i }` ]
		const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

		let defaultPretitle = ''
		let defaultTitle = ''
		let defaultSubtitle = ''
		let defaultImg = ''

		if ( i % 5 === 1 ) {
			defaultPretitle = 'World of music with'
			defaultTitle = 'Headphones'
			defaultSubtitle = 'Choose between top brands'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img4.jpg`
		}
		if ( i % 5 === 2 ) {
			defaultPretitle = 'Explore the best'
			defaultTitle = 'VR Collection'
			defaultSubtitle = 'on the market'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img5.jpg`
		}
		if ( i % 5 === 3 ) {
			defaultPretitle = 'Check our huge'
			defaultTitle = 'Smartphones'
			defaultSubtitle = '& Accessories collection'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img6.jpg`
		}
		if ( i % 5 === 4 ) {
			defaultPretitle = 'World of music with'
			defaultTitle = 'Headphones'
			defaultSubtitle = 'Choose between top brands'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img4-1.jpg`
		}
		if ( i % 5 === 0 ) {
			defaultPretitle = 'Explore the best'
			defaultTitle = 'VR Collection'
			defaultSubtitle = 'on the market'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img5-1.jpg`
		}

		const pretitleComp = enablepreTitle && (
			<RichText.Content
				tagName="h2"
				value={ Pretitle || defaultPretitle }
				className={ `font-weight-light pb-1 from-bottom text-dark` }
			/>
		)

		const titleComp = enableTitle && (
			<RichText.Content
				tagName="h1"
				className={ `display-4 from-bottom delay-1 text-dark` } 
				value={ Title || defaultTitle }
			/>
		)

		const subtitleComp = enablesubTitle &&  (
			<RichText.Content
				tagName="h5"
				value={ subTitle || defaultSubtitle }
				className={ `font-weight-light pb-3 from-bottom delay-2 text-dark` }
			/>
		)

		const buttonComp = enableButton && (
			<ButtonEditHelper.Content
				attrNameTemplate={ `button${ i }%s"` }
				blockAttributes={ props.attributes }
			/>
		)

		const output = (
			<div className="slide-wrapper" key={ i }>
				<div className="row align-items-center" key={ i }>
					<div className="col-md-6 order-md-2">
						<img className="d-block mx-auto" src={ MediaURL1 !== undefined ? MediaURL1 : defaultImg } alt="Vr Collection" />
					</div>
					<div className="col-lg-5 col-md-6 offset-lg-1 order-md-1 pt-4 pb-md-4 text-center text-md-left">
						{ pretitleComp }
						{ titleComp }
						{ subtitleComp }
						{ buttonComp }
					</div>
				</div>
			</div>
		)
			
		return output
	} )

	const sidecontent = range( 1, bannerlimit + 1 ).map( j => {

		const bannerTitle = attributes[ `bannertitle${ j }` ]
		const link = attributes[ `link${ j }` ] !== undefined ? attributes[ `link${ j }` ]  : '#'
		const MediaURL2 = attributes[ `mediaURL2${ j }` ]
		const shopLink = attributes[ `shoplink${ j }` ]
		const bannerbgcolor = attributes[ `bannerbgcolor${ j }` ]
		const bannercustombgcolor = attributes[ `bannercustombgcolor${ j }` ]
		const bannertextcolor = attributes[ `bannertextcolor${ j }` ]
		const custombannertextcolor = attributes[ `custombannertextcolor${ j }` ]

		const bannerbgstyle = { backgroundColor: bannercustombgcolor && bannercustombgcolor }


		let defaultbannerTitle = ''
		let defaultShopLink = ''
		let defaultImg = ''

		if ( j % 3 === 1 ) {
			defaultbannerTitle = '<span class="font-weight-light">Next Gen</span><br>Video <span class="font-weight-light">with</span><br>360 Cam'
			defaultImg = `${ pluginAssetsURL }img/banner/img1.png`
			defaultShopLink = 'Shop Now'
		}
		if ( j % 3 === 2 ) {
			defaultbannerTitle = '<span class="font-weight-light">Top Rated</span><br>Gadgets<br><span class="font-weight-light">are on </span>Sale'
			defaultImg = `${ pluginAssetsURL }img/banner/img2.png`
			defaultShopLink = 'Shop Now'
		}
		if ( j % 3 === 0 ) {
			defaultbannerTitle = '<span class="font-weight-light">Catch Big</span><br>Deals <span class="font-weight-light">on</span><br>Earbuds'
			defaultImg = `${ pluginAssetsURL }img/banner/img3.png`
			defaultShopLink = 'Shop Now'
		}

		const BannerTitle =(
			<RichText.Content
				tagName="h5"
				value={ bannerTitle || defaultbannerTitle }
				className={ `mb-2` }
			/>
		)
		const ShopLink =(
			<Fragment>
				<RichText.Content
					tagName="div"
					value={ shopLink || defaultShopLink }
					className={ `${ bannertextcolor ? bannertextcolor : custombannertextcolor ? '' : j === 1 ? 'text-info' : j === 2 ? 'text-warning' : j === 3 ? 'text-success' : ''  } font-size-sm d-inline` }
					style={ { color: custombannertextcolor } }
				/>
				<i className={ `czi-arrow-right font-size-xs ml-1 ${ bannertextcolor ? bannertextcolor : custombannertextcolor ? '' : j === 1 ? 'text-info' : j === 2 ? 'text-warning' : j === 3 ? 'text-success' : ''  }` }></i>
			</Fragment>	
		)

		const output = (
			<a className={ `media w-100 align-items-center ${ bannerbgcolor ? bannerbgcolor : bannercustombgcolor ? '' : j === 1 ? 'bg-faded-info' : j === 2 ? 'bg-faded-warning' : j === 3 ? 'bg-faded-success' : '' } rounded-lg pt-2 pl-2 mb-4 mr-4 mr-xl-0 ` } href={ link } style={ bannerbgstyle }  key={ j }>
				<img src={ MediaURL2 !== undefined ? MediaURL2 : defaultImg } width="125" alt="Banner" />
				<div className="media-body py-4 px-2">
					{ BannerTitle }
					{ ShopLink }
				</div>
			</a>
		)

		return output
	} )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-2.main-block.classes', {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots : true,
		arrows : false,
		adaptiveHeight : true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		speed: 500,
		pauseOnHover: true,
	}, props )

	let carouselOptions = {
		slidesToShow: 1,
		dots: true,
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
	] )

	return (
		<div id={ blockId } className={ mainClasses }>
			<section className={ `${ bgcolor ? bgcolor : custombgcolor ? '' : 'bg-secondary' } py-4 pt-md-5` } style={ bgstyle } >
				<div className="container py-xl-2">
					<div className="row align-items-center">
						<div className="col-xl-9 pt-xl-4 order-xl-2">
							<div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</div>
						<div className="col-xl-3 order-xl-1 pt-4 mt-3 mt-xl-0 pt-xl-0">
							<div className="d-flex d-xl-block sidebanner">
								{ sidecontent }
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}


const deprecated = [
	{
		attributes: schema_1,
		save: save_1,
	},
	{
		attributes: schema_2,
		save: save_2,
	},
]

export default deprecated